import Sidenav from "./components/Sidenav/Sidenav";
import Topnav from "./components/Topnav/Topnav";
import Discover from "./routes/Discover/Discover";
import DiscoverByGenre from "./routes/DiscoverByGenre/DiscoverByGenre";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
import Home from "./routes/Home/Home";
import Login from "./routes/Login/Login";
import Register from "./routes/Register/Register";
import ForgotPassword from "./routes/ForgotPassword/ForgotPassword";
import ResetPassword from "./routes/ResetPassword/ResetPassword";
import SingleProduct from "./routes/SingleProduct/SingleProduct";
import ProductReviews from "./routes/ProductReviews/ProductReviews";
import Library from "./routes/Library/Library";
import Favorites from "./routes/Favorites/Favorites";
import Privacy from "./routes/Privacy/Privacy";
import TermsOfService from "./routes/TermsOfService/TermsOfService";
import Profile from "./routes/Profile/Profile";
import Cart from "./routes/Cart/Cart";
import { Routes, Route, useLocation } from "react-router-dom";
import "./App.css";
import { useState } from "react";
import Ebook from "./routes/Ebook/Ebook";

function App() {
  const [openSidenav, setOpenSidenav] = useState(false);
  const location = useLocation();

  const hideTopnav = /^\/product\/[^/]+\/stream$/.test(location.pathname);

  return (
    <div className="App">
      <Sidenav openSidenav={openSidenav} setOpenSidenav={setOpenSidenav} />
      <div className={`app-wrapper ${openSidenav ? "open" : ""}`}>
        {!hideTopnav && <Topnav setOpenSidenav={setOpenSidenav} />}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/discover" element={<Discover />} />
          <Route path="/discover/:tag" element={<DiscoverByGenre />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/product/:slug" element={<SingleProduct />} />
          <Route path="/product/:slug/reviews" element={<ProductReviews />} />
          <Route element={<ProtectedRoute />}>
            <Route path="/product/:slug/stream" element={<Ebook />} />
            <Route path="/library" element={<Library />} />
            <Route path="/favorites" element={<Favorites />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
          </Route>
        </Routes>
      </div>
    </div>
  );
}

export default App;
